import { render, staticRenderFns } from "./CatalogView.vue?vue&type=template&id=74339fe8&scoped=true&"
import script from "./CatalogView.vue?vue&type=script&lang=js&"
export * from "./CatalogView.vue?vue&type=script&lang=js&"
import style0 from "./CatalogView.vue?vue&type=style&index=0&id=74339fe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74339fe8",
  null
  
)

export default component.exports